<template>
  <div class="container">
      <div class="row">
        <div class="col-xl-12 col-xs-12 block" id="nav">
          <router-link tag="a" to="/" class="link">
            <img src="@/assets/brand.png" class="ico" width="150"/>
          </router-link>
          <div class="content-right hidden-xs">
            <div v-if="authenticated && user_data.email_verified">
              <router-link to="/lookup" :class="[$router.currentRoute.name === 'lookup'? 'link-blue': 'link']">Single record lookup </router-link>
              <router-link to="/" :class="[$router.currentRoute.name === 'upload_leads'? 'link-blue': 'link']">Bulk CSV enrich</router-link>
              <div class="dropdown">
                <Span class="link dropdown blue">
                  {{ user_data.full_name }}
                  <i class="fa fa-caret-down" aria-hidden="true"></i>
                </Span>
                <div class="dropdown-content">
                  <router-link to="/user/account">Account</router-link>
                  <router-link to="/user/billing">Billing</router-link>
                  <a
                    :href="'/login?token='+user_data.access_token"
                    v-if="(admins.indexOf(user_data.email) > -1)"
                    target="_blank">
                    Admin
                  </a>
                  <a href="mailto:team@orbitly.io">
                    Support
                  </a>
                  <a href="#" @click="LogOut">Logout</a>
                </div>
              </div>
            </div>
            <div v-if="!authenticated || !user_data.email_verified">
              <a href="https://www.orbitly.io/pricing" class="link" target="_blank">Pricing</a>
              <a href="https://www.orbitly.io/resources" class="link" target="_blank">Resources</a>
              <router-link to="/user/login" tag="button" class="btn btn-1 btn-small">Sign In</router-link>
            </div>
        </div>

        <div id="mySidenav" :class="[menu ? 'sidenav-true visible-xs-inline-block': 'sidenav visible-xs-inline-block']" @click="menu = false">
          <span @click="menu = false" class="closebtn cursor">&times;</span>
          <div v-if="authenticated && user_data.email_verified">
            <router-link to="/lookup" :class="[$router.currentRoute.name === 'lookup'? 'link-blue': 'link']">
              <div class="sidenav-icon-container m-r-10"><i class="fas fa-search" /></div>
              Single record lookup
            </router-link>
            <router-link to="/" :class="[$router.currentRoute.name === 'upload_leads'? 'link-blue': 'link']">
              <div class="sidenav-icon-container m-r-10"><i class="fas fa-file-csv" /></div>
              Bulk CSV enrich
            </router-link>
            <router-link to="/user/account" class="link">
              <div class="sidenav-icon-container m-r-10"><i class="fas fa-user" /></div>
              Account
            </router-link>
            <router-link to="/user/billing" class="link">
              <div class="sidenav-icon-container m-r-10"><i class="fas fa-wallet" /></div>
              Billing
            </router-link>
            <a href="#" @click="LogOut" class="link">
              <div class="sidenav-icon-container m-r-10"><i class="fas fa-sign-out-alt" /></div>
              Logout
            </a>
          </div>

          <div v-if="!authenticated || !user_data.email_verified">
            <a href="https://www.orbitly.io/pricing" class="link" target="_blank">
              <div class="sidenav-icon-container m-r-10"><i class="fas fa-money-bill-alt" /></div>
              Pricing
            </a>
            <a href="https://www.orbitly.io/resources" class="link" target="_blank">
              <div class="sidenav-icon-container m-r-10"><i class="fas fa-book" /></div>
              Resources
            </a>
            <router-link to="/user/login" class="link">
              <div class="sidenav-icon-container m-r-10"><i class="fas fa-user" /></div>
              Sign In
            </router-link>
          </div>
        </div>
        <div class="content-right visible-xs" @click="menu = true">
          <i class="fas fa-bars fa-2x cursor" />
        </div>

      </div>
    </div>

    <div id="page-container">
      <div id="content-wrap">
        <router-view />
      </div>
      <FooterComponent />
    </div>
  </div>
</template>

<script>

import Vue from 'vue'
import 'vue-flash-message/dist/vue-flash-message.min.css'
import FooterComponent from '@/components/FooterComponent.vue'
import { mapMutations } from 'vuex'

export default {
  name: 'app',
  components: {
    FooterComponent
  },
  mounted () {
    this.changeLoaderState(false)
    if (this.authenticated) {
      this.$http.get('/api/user').then((res) => {
        this.setAuthUser(res.data)
      })
    }
    var crypto = require('crypto')
    var shasum = crypto.createHash('sha1')
    shasum.update(this.$store.state.user.data.email)    
    dataLayer.push({'email': shasum.digest('hex') });
    dataLayer.push({'user_id': this.$store.state.user.data.id});
  },
  data () {
    return {
      menu: false,
      admins: ['arosha@socialcatfish.com','david.mcclellan.sd@gmail.com','brian@socialcatfish.com','mark@orbitly.io','shelley@socialcatfish.com','breanne.searchspecialist@socialcatfish.com']
    }
  },
  methods: {
    ...mapMutations('user', [
      'logOut',
      'changeLoaderState',
      'setAuthUser'
    ]),
    ...mapMutations([
      'uploadedLeadList/setFileData',
      'uploadedLeadList/clearData'
    ]),
    admin () {
      window.open('https://www.w3schools.com', '_blank', 'toolbar=yes,scrollbars=yes,resizable=yes,top=500,left=500,width=400,height=400')
    },
    LogOut () {
      Vue.http.headers.common['Authorization'] = 'Bearer '
      this.logOut()
      this['uploadedLeadList/setFileData']({ file: false, state: 'default', credits: 0, text: '' })
      this['uploadedLeadList/clearData']()
      this.$router.push({ name: 'login' })
      // this.$router.go()
    }
  },
  computed: {
    authenticated: function () {
      return this.$store.state.user.authenticated
    },
    user_data: function () {
      return this.$store.state.user.data
    }
  }
}
</script>

<style lang="scss">

.sidenav-true {
  height: 100%;
  width: 300px;
  position: fixed;
  z-index: 3;
  top: 0;
  right: 0;
  background-color: $light-1;
  overflow-x: hidden;
  transition: 0.1s;
  padding-top: 60px;
}

.sidenav {
  height: 100%;
  width: 0px;
  position: fixed;
  z-index: 3;
  top: 0;
  right: 0;
  background-color: $light-1;
  overflow-x: hidden;
  transition: 0.1s;
  padding-top: 60px;
}

.sidenav-true a {
  padding: 8px 8px 8px 32px;
  text-decoration: none;
  font-size: 15px;
  color: $color-1;
  display: block;
  transition: 0.3s;
}

.sidenav-icon-container {
  width: 25px;
  text-align: center;
  display: inline-block;
}

.sidenav a {
  padding: 8px 8px 8px 32px;
  text-decoration: none;
  font-size: 15px;
  color: $color-1;
  display: block;
  transition: 0.3s;
}

.sidenav-true a:hover {
  color: $color-2;
}

.sidenav a:hover {
  color: $color-2;
}

.closebtn {
  position: absolute;
  top: 0;
  right: 25px;
  font-size: 36px;
  margin-left: 50px;
}

.cursor {
  cursor: pointer;
}

 #page-container {
    position: relative;
    min-height: 100%;
  }

  #content-wrap {
    padding-bottom: 2.5rem; /* Footer height */
  }

  #footer {
    //position: absolute;
    bottom: 0;
    width: 100%;
    height: 2.5rem;  /* Footer height */
  }

   .iframe-footer {
    position:absolute;
    width:100%;
    height:360px;
    overflow: hidden;
  }

  @media only screen and (max-width: 600px) {
     .iframe-footer {
       height: 100vh;
       width: 100%
      }
      #footer {
        width: 100%;
        height: 100vh;
      }
   }

.enrich-btn {
  margin-top: 15px;
}

.checkboxes {
  margin-top: 15px;
  .box-ul {
    display: inline-block;
    width: 190px;
    ul {
      margin: 0;
      list-style: none;
      padding: 0;
      li {
        text-align: left;
      }
    }
  }
}

.credit-text {
  color: $color-1;
}

.signo {
  height: 20px;
  width: 20px;
  margin-left: 5px;
  color: #F9F9F9;
  background-color: black;
  border-radius: 50%;
  display: inline-block;
  vertical-align: middle;
}

.signo:hover {
  cursor: default;
}

.csv-format {
  display: block;
  margin-top: 10px;
  font-size: 14px;
  text-decoration: none;
  text-align: center;
  color: $gray-1;
}

.csv-format:hover {
  text-decoration: underline;
}

.dotted {
    margin-top: 10px;
    border-style: dashed;
    border-width: 2px;
    border-color: $gray-1;
    border-radius: 2px;
}

.hover:hover {
    background: $gray-2;
}

.dotted-content-load {
    text-align: center;
    vertical-align: middle;
    padding: 50px;
    background: #F9F9F9;
    .browse {
        padding: 0px auto;
        cursor: pointer;
        color: $color-1;
    }
}

.dotted-content {
    text-align: center;
    vertical-align: middle;
    padding: 50px;
    cursor: pointer;
    input[type="file"] {
        position: absolute;
        left: 0;
        opacity: 0;
        top: 0;
        bottom: 0;
        width: 100%;
        cursor: pointer;
    }
    label {
        display: inline-block;
        position: relative;
        color: $color-1;
    }
}

.my-btn {
  border: 1px solid $color-1;
  border-radius: 5px;
  background-color: $color-1;
  text-decoration: none;
  vertical-align: middle;
  display: inline-block;
}

.my-btn i {
  color: white;
  padding: 10px;
}

.btn-text {
  background-color: white;
  text-decoration: none;
  text-align: center;
  font-weight: bold;
  color: $color-1;
  padding: 10px 25px;
  display: -webkit-inline-box;
  display: inline-block;
  border-radius: 5px 0px 0px 5px;
}

.btn-text-details {
  background-color: white;
  text-decoration: none;
  text-align: center;
  font-weight: bold;
  color: $color-1;
  padding: 10px 25px;
  display: -webkit-inline-box;
  display: inline-block;
  border-radius: 5px;
}

.block {
    background-color: white;
}

// navbar with drop-down menu
.dropdown {
  position: relative;
  display: inline-block;
}

.dropdown-content {
  display: none;
  position: absolute;
  background-color: $light;
  min-width: 160px;
  border-radius: 5px;
  box-shadow: 0 3px 10px 1px #d2d2d2;
  z-index: 3;
  a {
    color: $dark-1;
    padding: 12px 16px;
    text-decoration: none;
    display: block;
  }
  a:hover {color: $color-1}
}

.dropdown:hover .dropdown-content {
  display: block;
}

.dropdown:hover {
  color: $color-1;
}

.link {
  cursor: pointer;
  text-decoration: none;
  color: $dark-1;
  font-weight: bold;
  margin: 15px;
}

.link-blue {
  cursor: pointer;
  text-decoration: none;
  color: $color-1;
  font-weight: bold;
  margin: 15px;
}

.dot {
  height: 20px;
  width: 20px;
  margin-right: 4px;
  background-color: $color-1;
  border-radius: 50%;
  display: inline-block;
  vertical-align: middle;
}

.content-right {
  float: right;
}

.form-down-content {
  text-align: center;
}

.form-medium-content {
  margin-top: 20px;
  margin-bottom: 20px;
}

.register-link {
  text-decoration: none;
  font-weight: bold;
  color: $color-1;
}

.vcenter {
    position: relative;
    height: 80vh;
}

@media screen and (max-width: 600px){
  .vcenter {
    height: 100vh;
  }
  .form-middle {
    margin: auto;
    width: 400px;
    max-width: 100%;
    text-align: left;
  }
  .form-middle-lookup {
    margin: auto;
    text-align: left;
  }
}

.user-form {
    margin: auto;
    width: 400px;
    max-width: 100%;
    text-align: left;
    justify-content: center;
    vertical-align: middle;
}

.form-middle {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    margin: auto;
    width: 400px;
    max-width: 100%;
    text-align: left;
    justify-content: center;
    vertical-align: middle;
}

.form-middle-lookup {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    margin: auto;
    text-align: left;
    justify-content: center;
    vertical-align: middle;
}

.title-form {
    text-align: center;
    margin-bottom: 20px;
}

.font {
  background-color: #F2F2F8;
}

#nav {
  padding: 15px;
  display: inline-block;
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
}

#plus {
  padding: 0 20px 0 20px;
  display: inline-block;
  font-size: 50px;
  vertical-align: top;
  line-height: 100px;
}

// STYLE GUIDE
body {
  font-family:  Neurialgrotesk, sans-serif;
  font-size: 14px;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: $dark-1;
}

// headings
h1 {
  margin-top: 20px;
  margin-bottom: 10px;
  color: $dark-1;
  font-size: 38px;
  line-height: 44px;
  font-weight: 700;
}

h2 {
  margin-top: 20px;
  margin-bottom: 10px;
  color: $dark-1;
  font-size: 32px;
  line-height: 36px;
  font-weight: 700;
}

h3 {
  margin-top: 20px;
  margin-bottom: 10px;
  color: $dark-1;
  font-size: 24px;
  line-height: 30px;
  font-weight: 700;
}

h4 {
  margin-top: 10px;
  margin-bottom: 10px;
  color: $dark-1;
  font-size: 18px;
  line-height: 24px;
  font-weight: 700;
}

h5 {
  margin-top: 10px;
  margin-bottom: 10px;
  color: $dark-1;
  font-size: 14px;
  line-height: 20px;
  font-weight: 700;
}

h6 {
  margin-top: 10px;
  margin-bottom: 10px;
  color: $dark-1;
  font-size: 12px;
  line-height: 18px;
  font-weight: 700;
}

// buttons
.btn {
  margin: 5px 5px 5px 0px;
  padding: 15px 40px;
  border: none;
  border-radius: 4px;
  background-color: $color-1;
  font-weight: 500;
  font-size: 16px;
  color: $light-1;
}

.btn-large {
  width: 98%;
}

.btn:hover {
  background-color: lighten($color-1, 10%);
  cursor: pointer;
}

.btn-small {
  padding: 12px 25px;
  border-radius: 5px;
  font-size: 13px;
}

.btn-smaller {
  padding: 10px 20px;
  font-size: 12px;
}

.btn-big {
  padding: 20px 50px;
  font-size: 18px;
}

.btn-bigger {
  padding: 25px 60px;
  font-size: 20px;
}

.btn-1 {
  background-color: #fff;
  margin-right: 10px;
  color: $color-1;
  border-color: $color-1;
  border-width: 1px;
  border-style: solid;
}

.btn-1:hover {
  background-color: darken(white, 5%);
}

.logo-container {
  margin-top: 5px;
  margin-right: 5px;
  margin-bottom: 5px;
}

.card-content {
  width: auto;
  height: auto;
  padding: 10px;
  border-radius: 5px;
  border-style: solid;
  border-width: 1px;
  border-color: $gray-2;
  background-color: $light-1;
}

.card-content-2 {
  width: auto;
  height: auto;
  padding: 10px;
  border-radius: 5px;
  border-style: solid;
  border-width: 2px;
  border-color: $gray-2;
  background-color: white;
}

.smaller {
  font-size: 10px;
}

.small {
  font-size: 12px;
}

.big {
  font-size: 16px;
}

.bigger {
  font-size: 18px;
}

.biggest {
  font-size: 22px;
}

.bold {
  font-weight: 700;
}

.light {
  font-weight: 300;
}

.medium {
  font-weight: 500;
}

.dim {
  color: $gray-1;
}

.input-form {
  min-height: 35px;
  min-width: 250px;
  padding: 15px 10px 2px;
  border-style: solid;
  border-width: 1px;
  border-color: $dark-1;
  border-radius: 5px;
  color: $dark-1;
  margin-right: 10px;
  font-size: 16px;
  vertical-align: top;
}

textarea {
  padding: 22px 10px 2px;
}

/**
* Make the field a flex-container, reverse the order so label is on top.
*/
.field {
  display: flex;
  flex-flow: column-reverse;
  margin-bottom: 1em;
}

label, input, textarea {
  transition: all 0.2s;
  touch-action: manipulation;
}

input[class*=input-form] + label, textarea + label {
  cursor: pointer;
  position: relative;
  top: 20px;
  font-size: 11px;
  font-weight: bold;
  margin-left: 10px;
  margin-bottom: 3px
}

/**
* By default, the placeholder should be transparent. Also, it should
* inherit the transition.
*/
::-webkit-input-placeholder {
  opacity: 0;
  transition: inherit;
}
/**
* Show the placeholder when the input is focused.
*/
input:focus::-webkit-input-placeholder, textarea:focus::-webkit-input-placeholder {
  opacity: 1;
}

select {
  margin-right: 10px;
  min-height: 30px;
}

// spinner
.spinner {
  width: 40px;
  height: 40px;

  position: relative;
  margin: 100px auto;
}

.double-bounce1, .double-bounce2 {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background-color: $color-1;
  opacity: 0.6;
  position: absolute;
  top: 0;
  left: 0;

  -webkit-animation: sk-bounce 2.0s infinite ease-in-out;
  animation: sk-bounce 2.0s infinite ease-in-out;
}

.double-bounce2 {
  -webkit-animation-delay: -1.0s;
  animation-delay: -1.0s;
}

@-webkit-keyframes sk-bounce {
  0%, 100% { -webkit-transform: scale(0.0) }
  50% { -webkit-transform: scale(1.0) }
}

@keyframes sk-bounce {
  0%, 100% {
    transform: scale(0.0);
    -webkit-transform: scale(0.0);
  } 50% {
    transform: scale(1.0);
    -webkit-transform: scale(1.0);
  }
}
</style>
